import React from "react";
import { BriefcaseIcon, CalendarIcon, LocationIcon } from "assets/Images";
import { calculateDuration } from "utils/functions";
import styles from "./ExperienceCard.module.scss";
import ExperiencePositionCard from "./ExperiencePositionCard";

const ExperienceCard = ({
  companyName,
  companyIntro,
  location,
  startDate,
  endDate,
  positions,
  isLast,
}) => {
  return (
    <div className={styles.experienceCard}>
      <div className={styles.timelineMarker}>
        <div className={styles.briefcaseCnt}>
          <BriefcaseIcon size={28} />
        </div>
        {!isLast && <div className={styles.timelineLine} />}
      </div>

      <div className={styles.cardContent}>
        <div className={styles.companyHeader}>
          <div className={styles.companyInfo}>
            <h3 className={styles.companyName}>{companyName}</h3>
            <div className={styles.companyIntro}>{companyIntro}</div>
            <div className={styles.locationRow}>
              <LocationIcon size={18} className={styles.locationIcon} />
              <span className={styles.location}>{location}</span>
            </div>
            <div className={styles.durationRow}>
              <CalendarIcon size={16} className={styles.calendarIcon} />
              <span className={styles.duration}>
                <span>
                  {startDate} - {endDate}
                </span>
                <span>&nbsp;({calculateDuration(startDate, endDate)})</span>
              </span>
            </div>
          </div>
        </div>

        <div className={styles.positionsContainer}>
          {positions?.map((position, index) => (
            <ExperiencePositionCard key={index} position={position} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExperienceCard;
